<template>
    <div class="edit_wrap">
        <!-- tab -->
        <div class="add_top">
            <div class="add_tab active_tab">品牌详情</div>
        </div>
        <!-- 品牌详情 -->
        <div class="choice_brand mt20 mb20">
            <!-- 中英文名称 -->
            <div class="add_name">
                <div class="c_name">
                    <!-- <span class="main_word mr4">*</span> -->
                    <span class="form_color">品牌中文名称：</span>
                    <span class="f999">{{brandDetails.brandName}}</span>
                    <span class="main_word"  v-if="snapshot && snapshot.brandName">&nbsp;&nbsp; {{ snapshot.brandName }}</span>
                </div>
                <div class="e_name">
                    <span class="form_color">品牌英文名称：</span>
                    <span class="f999">{{brandDetails.brandEnname}}</span>
                    <span class="main_word" v-if="snapshot && snapshot.brandEnname">&nbsp;&nbsp; {{ snapshot.brandEnname }}</span>
                </div>
                <div class="e_name" v-if="brandDetails.brandDesc">
                    <span class="form_color">品牌介绍：</span>
                    <span class="f999">{{brandDetails.brandDesc}}</span>
                    <span class="main_word" v-if="snapshot && snapshot.brandDesc">&nbsp;&nbsp; {{ snapshot.brandDesc }}</span>
                </div>
                <div class="e_name" v-if="brandDetails.brandGoodsDesc">
                    <span class="form_color">重点商品：</span>
                    <span class="f999">{{brandDetails.brandGoodsDesc}}</span>
                    <span class="main_word" v-if="snapshot && snapshot.brandGoodsDesc">&nbsp;&nbsp; {{ snapshot.brandGoodsDesc }}</span>
                </div>
            </div>
            <!-- 信息验证 -->

            <el-form label-width="207px" class="demo-ruleForm">
                <el-form-item class="ml50" label="选择大V已录入的品牌：" v-if="hasSelBrand == 1 && (brandDetails.brandId == null || brandDetails.brandId == 0)">
                    <template>
                        <el-select v-model="brandId" filterable remote
                            placeholder="请输入关键词"
                            :remote-method="initBrandList"
                            :loading="loading">
                            <el-option v-for="item in options" :key="item.brandId" :label="item.brandName" :value="item.brandId">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
                <p></p>
                <div class="ml97 mt10" v-if="hasSelBrand == 1 && (brandDetails.brandId == null || brandDetails.brandId == 0)">
                    <span class="main_word">如果大V服务平台还没有该品牌，请现在ECShop添加要用的品牌信息</span>
                </div>

                <el-form-item label="品类合作类型：">
                    <el-checkbox-group class="dib vtb ml_10" v-model="categoryType">
                        <el-checkbox label="1" disabled>图书类</el-checkbox>
                        <el-checkbox label="2" disabled>非图书类</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="品牌合作品类：">
                </el-form-item>

                <el-form-item label-width="60px">
                    <template scope="scope" v-if="brandDetails.categories && brandDetails.categories.length > 0">
                        <el-table :data="brandDetails.categories" border style="width: 92%;margin: 0 auto;">
                            <el-table-column label="主营品类"
                                             width="200"
                                             align="center">
                                <template scope="scope">
                                    <span>{{ scope.row.category.grandName }}--</span>
                                    <span>{{ scope.row.category.parentName }}--</span>
                                    <span>{{ scope.row.category.childrenName }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="是否提供发票"
                                             width="140"
                                             align="center">
                                <template scope="scope">
                                    <span v-if="scope.row.provideInvoice==0">否</span>
                                    <span v-if="scope.row.provideInvoice==1">是</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="发票类型" align="center" width="180">
                                <template scope="scope">
                                    <span v-if="scope.row.provideInvoice==0">无</span>
                                    <span v-if="scope.row.provideInvoice==1 && registeredCountry == 1 && scope.row.invoiceType == 1">增值税普通发票</span>
                                    <span v-if="scope.row.provideInvoice==1 && taxpayerType==1 && registeredCountry == 1 && scope.row.invoiceType == 2">增值税专用发票</span>
                                    <span v-if="scope.row.provideInvoice==1 && taxpayerType==2 && registeredCountry == 1 && scope.row.invoiceType == 2">增值税专用发票（需去税务局代开）</span>
                                    <span v-if="scope.row.provideInvoice==1 && registeredCountry != 1 && scope.row.invoiceType == 3">形式发票</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="税率" align="center" min-width="150">
                                <template scope="scope">
                                    <span v-if="scope.row.rates.length==0">无</span>
                                    <span v-if="scope.row.rates.length>0" v-for="rateValue in scope.row.rates">
                                    {{rateValue}}%
                                    </span>
                                </template>
                            </el-table-column>

                            <el-table-column width="200" label="品类经营特许资质电子版" align="center">
                                <template scope="scope" >
                                    <img v-if="scope.row.franchiseQualification == 1" @click="previewPic($event)"
                                         class="pic_skan" :src="scope.row.franchiseQualificationFile">
                                    <span v-if="!scope.row.franchiseQualification == 1">不需要</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </el-form-item>

                <div v-if="brandDetails.categoryNotBook == 1">
                    <!-- 商品是否进口 -->
                    <el-form-item label="商品是否进口：">
                        <span v-if="brandDetails.goodsType == 1" class="f999 f12">非进口</span>
                        <span v-if="brandDetails.goodsType == 2" class="f999 f12">进口</span>
                        <span class="main_word" v-if="snapshot && snapshot.goodsType == 1">&nbsp;&nbsp; 非进口</span>
                        <span class="main_word" v-if="snapshot && snapshot.goodsType == 2">&nbsp;&nbsp; 进口</span>
                    </el-form-item>

                    <!-- 品牌经营方式 -->
                    <el-form-item label="品牌经营方式：">
                        <span v-if="brandDetails.businessType == 1" class="f999 f12">自有品牌</span>
                        <span v-if="brandDetails.businessType == 2" class="f999 f12">代理商</span>
                        <span v-if="brandDetails.businessType == 3" class="f999 f12">其他</span>
                        <span class="main_word" v-if="snapshot && snapshot.businessType == 1">&nbsp;&nbsp; 自有品牌</span>
                        <span class="main_word" v-if="snapshot && snapshot.businessType == 2">&nbsp;&nbsp; 代理商</span>
                        <span class="main_word" v-if="snapshot && snapshot.businessType == 3">&nbsp;&nbsp; 其他</span>
                    </el-form-item>
                    <!-- 商标注册证电子版 -->
                    <el-form-item v-if="brandDetails.businessType == 1 || brandDetails.businessType == 2"
                                  label="商标注册证电子版：">
                        <div>
                            <img v-if="brandDetails.trademarkRegistrationCertificateFiles" @click="previewPic($event)" v-for="rcFile in brandDetails.trademarkRegistrationCertificateFiles"
                                 class="pic_skan" :src="rcFile">
                            <img @click="previewPic($event)" class="pic_skan_red"
                                 v-for="srcFile in snapshot.trademarkRegistrationCertificateFiles"
                                 v-if="snapshot && srcFile" :src="srcFile">
                        </div>
                    </el-form-item>
                    <!-- 完整授权链证书电子版 -->
                    <el-form-item v-if="brandDetails.businessType == 1 || brandDetails.businessType == 2"
                                  label="完整授权链证书电子版：">
                        <div>
                            <img v-if="brandDetails.authCertificateFiles" @click="previewPic($event)" v-for="acFile in brandDetails.authCertificateFiles" class="pic_skan"
                                 :src="acFile">
                            <img @click="previewPic($event)" class="pic_skan_red" v-for="sacFile in snapshot.authCertificateFiles"
                                 v-if="snapshot && sacFile" :src="sacFile">
                        </div>
                    </el-form-item>
                    <!-- 订货单电子版 -->
                    <el-form-item v-if="brandDetails.businessType == 3" label="订货单电子版：">
                        <div>
                            <img v-if="brandDetails.purchaseOrderFiles" @click="previewPic($event)" v-for="poFile in brandDetails.purchaseOrderFiles" class="pic_skan"
                                 :src="poFile">
                            <img @click="previewPic($event)" class="pic_skan_red" v-for="spoFile in snapshot.purchaseOrderFiles"
                                 v-if="snapshot && spoFile" :src="spoFile">
                        </div>
                    </el-form-item>
                    <!-- 报关单扫描件 -->
                    <el-form-item v-if="brandDetails.goodsType == 2" v-show="(brandDetails.customsDeclarationFormFiles.length > 0 && brandDetails.customsDeclarationFormFiles[0]!='')" label="报关单扫描件：">
                        <div>
                            <img v-if="brandDetails.customsDeclarationFormFiles" @click="previewPic($event)" v-for="cdfFile in brandDetails.customsDeclarationFormFiles" class="pic_skan"
                                 :src="cdfFile">
                            <img @click="previewPic($event)" class="pic_skan_red" v-for="scdfFile in snapshot.customsDeclarationFormFiles"
                                 v-if="snapshot && scdfFile" :src="scdfFile">
                        </div>
                    </el-form-item>

                    <!-- 质检单电子版 -->
                    <el-form-item
                            v-if="brandDetails.registeredCountry==1 && brandDetails.goodsType == 1 && (brandDetails.businessType == 1 || brandDetails.businessType == 2)"
                            label="质检单电子版：">
                        <div>
                            <img v-if="brandDetails.qualityInspectionFiles" @click="previewPic($event)" v-for="qiFile in brandDetails.qualityInspectionFiles" class="pic_skan"
                                 :src="qiFile">
                            <img @click="previewPic($event)" class="pic_skan_red" v-for="sqiFile in snapshot.qualityInspectionFiles"
                                 v-if="snapshot && sqiFile" :src="sqiFile">
                        </div>
                    </el-form-item>
                    <!-- 入境货物检验检疫证明 -->
                    <el-form-item v-if="brandDetails.goodsType == 2" v-show="(brandDetails.inspectionQuarantineFiles.length > 0 && brandDetails.inspectionQuarantineFiles[0]!='')" label="入境货物检验检疫证明：" class="dib"
                                  prop="inspectionQuarantineFile">
                        <div>
                            <img v-if="brandDetails.inspectionQuarantineFiles" @click="previewPic($event)" v-for="iqFile in brandDetails.inspectionQuarantineFiles" class="pic_skan"
                                 :src="iqFile">
                            <img @click="previewPic($event)" class="pic_skan_red" v-for="siqFile in snapshot.inspectionQuarantineFiles"
                                 v-if="snapshot && siqFile" :src="siqFile">
                        </div>
                    </el-form-item>
                    <!-- 质检日期 -->
                    <el-form-item
                            v-if="brandDetails.registeredCountry==1 && brandDetails.goodsType == 1 && (brandDetails.businessType == 1 || brandDetails.businessType == 2)"
                            label="质检日期：" prop="qualityInspectionTime">
                        {{ brandDetails.qualityInspectionTime | time}}
                        <span class="main_word"
                              v-if="snapshot && snapshot.qualityInspectionTime">&nbsp;&nbsp; {{ snapshot.qualityInspectionTime | time
                            }}</span>
                    </el-form-item>
                </div>
            </el-form>

            <!-- 保存 -->
            <div align="center" class="mt20">
                <el-button type="primary" @click="reback()">返回</el-button>
                <el-button  v-if="hasSelBrand == 1 && (brandDetails.brandId == null || brandDetails.brandId == 0)" type="primary" @click="saveBrandRelation">保存</el-button>
            </div>
            <!--预览图片-->
            <el-dialog :visible.sync="dialogVisible" size="small">
                <img  width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </div>

    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                registeredCountry: 0,   // 注册地
                taxpayerType: 0,        // 纳税人类型
                deptId:0,               // 部门id

                brandDetails: {

                },

                loading:false,
                // 图片预览
                dialogImageUrl: '',
                dialogVisible: false,
                isChoice: true,				// tab 当前页面
                search_result: false,		// 搜索结果弹框
                brand_key: '',			// 品牌关键字搜索
                radio: null,							// 选中的内容,
                options: [],
                hasSelBrand:0,
                brandId:null,
                brandApplyId : 0,
                status : 0,                                        // 申请状态,Integer
                categoryType:[],                                    // 品类类型
                snapshot: {
                    trademarkRegistrationCertificateFiles :  [],                    // 商标注册电子版,String
                    purchaseOrderFiles :  [],                      // 订货单电子版,String
                    authCertificateFiles :  [],              // 完整授权链证书电子版,String
                    qualityInspectionFiles :  [],             // 质检单电子版,String
                    customsDeclarationFormFiles :  [],       // 报关单
                    inspectionQuarantineFiles :  [],          // 入境货物检验检疫证明,String
                }
            }
        },
        mounted () {
            var brandApplyId = this.$route.query.brandApplyId;
            if(this.$route.query.hasSelBrand) {
                this.hasSelBrand = this.$route.query.hasSelBrand;
            }
            this.brandApplyId = brandApplyId;
            if(brandApplyId){
                this.fetch(brandApplyId);
            }
        },

        methods: {
            initBrandList(query) {
                var that = this;
                if (query !== '' && query != null) {
                    $.get({
                        url: '/suppliers/supplierSettled/findBrandByKeyword',
                        dataType: "json",
                        data: {brandName:query},
                        success: function (result) {
                            if (!result.code) {
                                that.options = result.data.list;
                            } else {
                                that.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        },
                        error : function (err) {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    });
                }
            },

            // 预览图片
            previewPic (e) {
                console.log(e)
                this.dialogVisible = true;
                // 获取当前图片地址
                this.dialogImageUrl = e.currentTarget.src;
            },

            /**
             * 保存品牌关联关系
             */
            saveBrandRelation () {
                var that = this;
                if (!that.brandId) {
                    this.$message.error('请选择品牌');
                    return;
                }
                if(!that.brandApplyId) {
                    this.$message.error('申请的品牌信息有误');
                    return;
                }
                var Data = {};
                Data.brandApplyId = that.brandApplyId;
                Data.brandId = that.brandId;
                Data.brandAgreementId = 1;
                $.ajax({
                    url: '/suppliers/agreementApply/brandApply/bindBrand',
                    data: JSON.stringify(Data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST',
                    success: function (result) {
                        if (!result.code) {
                            that.$alert('绑定品牌保存成功', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    window.opener.eventHub.$emit('reloadBrandList',null);
                                    window.close();
                                }
                            });
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            fetch (brandApplyId) {
                var _this = this;
                $.get({
                    url: '/suppliers/agreementApply/brandApplyAndSnapshot/find',
                    data: {
                        brandApplyId: brandApplyId
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.brandDetails = result.data.lastest;
                            if (result.data.snapshot == null) {
                                _this.snapshot = {};
                            } else {
                                _this.snapshot = result.data.snapshot;
                            }
                            _this.registeredCountry = result.data.lastest.registeredCountry;
                            _this.taxpayerType = result.data.lastest.taxpayerType;
                            _this.deptId = result.data.lastest.deptId;

                            if (_this.brandDetails.brandId) {
                                _this.brandId = _this.brandDetails.brandId;
                            } else {
                                _this.brandId = null;
                            }

                            _this.status = _this.brandDetails.status;

                            if (_this.brandDetails.categoryIsBook == 1 && _this.brandDetails.categoryNotBook == 1) {
                                _this.categoryType = ["1","2"]
                            } else if (_this.brandDetails.categoryIsBook == 1 && _this.brandDetails.categoryNotBook == 0) {
                                _this.categoryType = ["1"]
                            } else if (_this.brandDetails.categoryIsBook == 0 && _this.brandDetails.categoryNotBook == 1) {
                                _this.categoryType = ["2"]
                            }

                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            reback(){
//                history.go(-1);
                 window.close();
            },
            // [] 图片转化成字符串
            fileTransToString(files){
                var fileStr = "";
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        if(files[i].url){
                            if(i!=0) {
                                fileStr += ",";
                            }
                            fileStr += files[i].url;
                        }
                    }
                }
                return fileStr;
            },
        },
        computed: {
            amount: function () {
                return 200 - this.addForm.brandDesc.length;
            }
        }
    }

</script>

<style type="text/css" lang="less" scoped>
    .edit_wrap {
        width: 1050px;
    // height: 4000px;
        margin: 50px auto;
        border: 1px solid #eee;
    .add_top {
        width: 100%;
        height: 40px;
        background-color: #f9f9f9;
    }
    .add_tab {
        display: inline-block;
        width: 170px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #666;
        font-size: 14px;
        cursor: pointer;
    }
    .active_tab {
        border-bottom: 1px solid #ff4a7d;
        color: #ff4a7d;
    }
    .add_name {
        padding-left: 96px;
    }
    }
    .choice_brand {
        min-height: 400px;
    }
    .w500 {
        width: 500px;
    }
    .w250 {
        width: 250px;
    }
    .w165 {
        width: 165px;
    }
    .radio_group {
        width: 90%;
        padding-left: 15%;
        max-height: 150px;
        overflow-y: scroll;
    }
    .list_radio {
        margin-top: 10px;
        margin-left: 10%;
        width: 40%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .mt120 {
        margin-top: 120px;
    }
    .result_radio .el-radio + .el-radio {
        margin-left: 10%;
    }
    .dialog-footer {
        text-align: center;
    }
    .form_color {
        color: rgb(106, 72, 77);
    }
    .c_name, .e_name {
        line-height: 36px;
    }
    .el-form-item {
        margin-bottom: 0;
    }
    .pic_skan {
        width: 150px;
        height: 150px;
        margin-top: 10px;
        margin-right: 5px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .pic_skan_red {
        width: 150px;
        height: 150px;
        margin-top: 10px;
        margin-right: 5px;
        border: 2px solid #ff4a7d;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .ml97 {
        margin-left: 97px;
    }
    .ml100 {
        margin-left: 100px;
    }
    .w140{
        width: 140px;
    }
</style>


// WEBPACK FOOTER //
// brand_compare_detail.vue?f1677d54